import { mode } from '@chakra-ui/theme-tools';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Dict = Record<string, any>;

const parts = ['text', 'icon'];

function baseStyleText(props: Dict) {
  return {
    color: mode('red.500', 'red.300')(props),
    mt: 1,
    lineHeight: 'normal',
    fontSize: 'sm',
  };
}

function baseStyleIcon(props: Dict) {
  return {
    mr: '0.5em',
    color: mode('red.500', 'red.300')(props),
  };
}

const baseStyle = (props: Dict) => ({
  text: baseStyleText(props),
  icon: baseStyleIcon(props),
});

export default {
  parts,
  baseStyle,
};
